module.exports = __webpack_public_path__ + "8e01a413f448298d354346749f1720e2.svg";